@if (errorMessage) {
    <div class="error-message alert alert-danger">{{ errorMessage }}</div>
}

<div *adaptLoadingUntilFirstEmit="let outstandingSurveyResponses of outstandingSurveyResponses$">
    @if (outstandingSurveyResponses.length < 1) {
        <div class="alert alert-info">There are currently no outstanding survey responses for this survey. All responses have been
            submitted.</div>
    } @else {
        <dx-data-grid [dataSource]="outstandingSurveyResponses"
                      [rowAlternationEnabled]="true"
                      [hoverStateEnabled]="true"
                      [showRowLines]="true"
                      [showBorders]="true">
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true"
                       [allowedPageSizes]="[5, 10, 20]"
                       [showInfo]="true"></dxo-pager>
            <dxi-column caption="Name"
                        [allowSorting]="true"
                        dataField="connection.person.fullName"
                        cellTemplate="fullNameCellTemplate"> </dxi-column>
            @if (showEmail) {
                <dxi-column caption="Email"
                            [allowSorting]="true"
                            [calculateCellValue]="getEmail"></dxi-column>
            }
            <dxi-column caption="Status"
                        [allowSorting]="true"
                        [sortIndex]="0"
                        sortOrder="asc"
                        [width]="150"
                        cellTemplate="statusTemplate"
                        [calculateCellValue]="getStatus"></dxi-column>
            <dxi-column type="buttons"
                        [width]="canCopySurveyLinks ? 60 : 30"
                        cellTemplate="actionTemplate"></dxi-column>
            <adapt-link-person *dxTemplate="let item of 'fullNameCellTemplate'"
                               [person]="item.data.connection?.person"></adapt-link-person>
            <div *dxTemplate="let item of 'statusTemplate'">
                <span>{{ item.value }}</span>
                @if (item.data.statusMessage) {
                    <i class="ms-1 fal fa-info-circle"
                       [adaptTooltip]="item.data.statusMessage"></i>
                }
            </div>
            <div *dxTemplate="let item of 'actionTemplate'">
                <!-- Note: Can't use blockingButtonGroup and blockingClick here as the tooltip won't go away
        TODO: leave that for another day when not waiting for this ticket to be released -->
                @if (reloading[item.data.connectionId]) {
                    <i class="fal fa-spinner fa-spin"></i>
                } @else {
                    <button class="btn btn-link"
                            adaptTooltip="Resend email"
                            adaptButtonIcon="fal fa-fw fa-share"
                            (click)="resendEmail(item.data.token, item.data.connection)"></button>
                    @if (canCopySurveyLinks) {
                        <button class="btn btn-link ms-2"
                                adaptTooltip="Copy survey link"
                                adaptButtonIcon="fal fa-fw fa-copy"
                                (click)="copySurveyLink(item.data.token)"></button>
                    }
                }
            </div>
        </dx-data-grid>
    }
</div>
@if (showNote) {
    <div class="mt-3 alert alert-info">Note that {{ adaptProjectLabel }} will only track survey responses which have not been submitted.
        Once a response is submitted, it can no longer be tracked.</div>
}
@if (showEndTime) {
    <div class="mt-3 d-flex align-items-center">
        <span class="me-3">The survey will end:</span>
        <dx-date-box type="datetime"
                     [openOnFieldClick]="true"
                     [displayFormat]="dateTimeDisplayFormat"
                     [showAnalogClock]="false"
                     [min]="minEndTime"
                     [value]="survey.endTime"
                     (valueChange)="onEndTimeChanged($any($event))"
                     data-test="survey-end-date-input"></dx-date-box>
    </div>
}
